import React from 'react';
import './Navigation.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse } from '@fortawesome/free-solid-svg-icons';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import MenuItem from '@mui/material/MenuItem';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import logo from '../assets/images/logo.svg';

const pages = ['projects', 'about', 'contact'];

function Navigation() {
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const themeGreen = '#00bf63';

    const darkTheme = createTheme({
        palette: {
            mode: 'dark',
            primary: {
                main: themeGreen,
            },
        },
        typography: {
            fontFamily: ['Montserrat', 'sans-serif'].join(','),
        },
    });

    return (
        <ThemeProvider theme={darkTheme}>
            <AppBar
                sx={{
                    position: 'relative',
                    backgroundColor: 'white',
                    boxShadow: 'none',
                }}
            >
                <Container maxWidth="xl">
                    <Toolbar disableGutters>
                        {/* Desktop View Logo */}
                        <Link
                            to="/"
                            style={{
                                textDecoration: 'none',
                                color: themeGreen,
                            }}
                        >
                            <Box sx={{ display: 'flex' }}>
                                <Box
                                    sx={{
                                        display: { xs: 'none', md: 'flex' },
                                        marginRight: '10px',
                                        color: themeGreen,
                                    }}
                                >
                                    <img src={logo} style={{ height: '80px', width: '220px' }} />
                                </Box>
                            </Box>
                        </Link>

                        {/* Mobile View Menu Icon */}
                        <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleOpenNavMenu}
                                sx={{ color: themeGreen }} // Green color applied here
                            >
                                <MenuIcon />
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorElNav}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                                open={Boolean(anchorElNav)}
                                onClose={handleCloseNavMenu}
                                sx={{
                                    display: { xs: 'block', md: 'none' },
                                }}
                            >
                                <MenuItem onClick={handleCloseNavMenu}>
                                    <Link
                                        to="/"
                                        style={{
                                            textAlign: 'center',
                                            color: themeGreen,
                                            textDecoration: 'none',
                                            textTransform: 'uppercase',
                                            fontWeight: 'bold',
                                            padding: '5px',
                                            letterSpacing: '1px',
                                        }}
                                    >
                                        Home
                                    </Link>
                                </MenuItem>
                                {pages.map((page) => (
                                    <MenuItem key={page} onClick={handleCloseNavMenu}>
                                        <Link
                                            to={`/${page}`}
                                            style={{
                                                textAlign: 'center',
                                                color: 'white',
                                                textDecoration: 'none',
                                                textTransform: 'uppercase',
                                                fontWeight: 'bold',
                                                padding: '5px',
                                                letterSpacing: '1px',
                                            }}
                                        >
                                            {page}
                                        </Link>
                                    </MenuItem>
                                ))}
                            </Menu>
                        </Box>

                        {/* Mobile View Logo */}
                        <Link
                            to="/"
                            style={{
                                textDecoration: 'none',
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                            }}
                        >
                            <Box
                                sx={{
                                    display: { xs: 'flex', md: 'none' },
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    color: themeGreen,
                                }}
                            >
                                <Box
                                    sx={{
                                        display: { xs: 'flex', md: 'none' },
                                        marginRight: '10px',
                                        color: themeGreen,
                                    }}
                                >
                                    <img src={logo} style={{ height: '45px', width: '200px' }} />
                                </Box>
                            </Box>
                        </Link>

                        {/* Desktop View Links */}
                        <Box
                            sx={{
                                flexGrow: 1,
                                display: { xs: 'none', md: 'flex' },
                                justifyContent: 'end',
                                alignItems: 'center',
                            }}
                        >
                            <Link
                                to="/"
                                style={{
                                    color: themeGreen,
                                    fontWeight: 'bold',
                                    textTransform: 'uppercase',
                                    textDecoration: 'none',
                                    letterSpacing: '1px',
                                }}
                            >
                                home
                            </Link>
                            {pages.map((page) => (
                                <Link
                                    key={page}
                                    onClick={handleCloseNavMenu}
                                    to={`/${page}`}
                                    style={{
                                        color: themeGreen,
                                        fontWeight: 'bold',
                                        textTransform: 'uppercase',
                                        marginLeft: '15px',
                                        textDecoration: 'none',
                                        letterSpacing: '1px',
                                    }}
                                >
                                    {page}
                                </Link>
                            ))}
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>
        </ThemeProvider>
    );
}

export default Navigation;
